export default "__VITE_ASSET__CWjt9Tgv__"